"use client";

import Image from 'next/image';
import { useState } from 'react';
import dynamic from 'next/dynamic';
const GalleryProduct = dynamic(() => import("./GalleryProduct"), {
    ssr: false
})
interface ProductURLTypeAlbum {
    id: number;
    album_image_src: string;
    album_image_alt: string;
    album_image_main: boolean;
    ProductIdentityId: number;
    CommentId: number | null;
}

interface ProductURLTypeData {
    Albums: ProductURLTypeAlbum[];
    product_image_alt: string;
    product_image: string;
}

interface GalleryProductProps {
    data: ProductURLTypeData;
    prodIID: number | undefined;
}

const GalleryImages = ({ data, prodIID }: GalleryProductProps) => {
    const albumImage = data?.Albums.filter((b) => b.ProductIdentityId === prodIID);


    const checkMainImage = albumImage?.filter((i) => i.album_image_main);
    const mainImage = checkMainImage?.length
        ? checkMainImage[0]
        : albumImage[0]
            ? albumImage[0]
            : {
                album_image_alt: data?.product_image_alt,
                album_image_src: data?.product_image,
            };

    const mainImageUrl = process.env.NEXT_PUBLIC_IMAGE_URL + mainImage?.album_image_src;



    const [index, setIndex] = useState(-1);

    return (
        <div>
            <div>
                <Image
                    height={600}
                    width={600}
                    alt={mainImage.album_image_alt}
                    src={mainImageUrl}
                    priority
                    onClick={() => setIndex(0)}
                    style={{ cursor: 'pointer' }}
                    sizes="(max-width: 600px) 100vw, 600px"
                />
                <GalleryProduct albumImage={albumImage} index={index} setIndex={setIndex} />
            </div>
        </div>
    );
};

export default GalleryImages;
